import { createContext, useContext, useState, ReactNode, useCallback } from "react";
import ContactForm from "./ContactForm";
import type { Division } from "@/lib/leadGuard";

export type ContactRequestType = "contacto" | "estudio-implantacion";
export type ContactOpenOpts = { division?: Division; requestType?: ContactRequestType };

type Ctx = { open: (opts?: ContactOpenOpts | unknown) => void; close: () => void; isOpen: boolean };

const ContactFormCtx = createContext<Ctx>({
  open: () => {},
  close: () => {},
  isOpen: false,
});

export const useContactForm = () => useContext(ContactFormCtx);

const isOpts = (v: unknown): v is ContactOpenOpts =>
  !!v && typeof v === "object" && !("nativeEvent" in (v as object)) && ("division" in (v as object) || "requestType" in (v as object));

export const ContactFormProvider = ({ children }: { children: ReactNode }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [opts, setOpts] = useState<ContactOpenOpts>({});

  // Accepts being used directly as an onClick handler (event is ignored).
  const open = useCallback((o?: ContactOpenOpts | unknown) => {
    setOpts(isOpts(o) ? o : {});
    setIsOpen(true);
  }, []);

  return (
    <ContactFormCtx.Provider value={{ isOpen, open, close: () => setIsOpen(false) }}>
      {children}
      <ContactForm
        open={isOpen}
        onClose={() => setIsOpen(false)}
        division={opts.division}
        requestType={opts.requestType ?? "contacto"}
      />
    </ContactFormCtx.Provider>
  );
};
